// extracted by mini-css-extract-plugin
module.exports = {"circle-slice":"CircleWithSlice_circle-slice__Fc9yY"};